import { Moment } from 'moment';
import { Model, ModelMixin } from '../../../domain/model/common/model.class';

export const ProfileStatusType = {
    IN_PROCESS: 'IN_PROCESS',
    CANCELLED: 'CANCELLED',
    ON_HOLD: 'ON_HOLD',
    COMPLETE: 'COMPLETE',
    EXPIRED: 'EXPIRED',
    NOT_APPROVED: 'NOT_APPROVED',
};

export interface ProfileStatusInteractionModel {
    completionDate: Moment | string | undefined;
    expirationDate: Moment | string | undefined;
    notes: string | undefined;
    recredentialDate: Moment | string | undefined;
    recredentialed: boolean;
    startDate: Moment | string | undefined;
    status: string;
}

export class ProfileStatusModel extends ModelMixin() implements Model<ProfileStatusModel> {
    TYPE = ProfileStatusModel;
    status: string = ProfileStatusType.IN_PROCESS;
    startDate: string = '';
    completionDate: string = '';
    expirationDate: string = '';
    recredentialDate: string = '';
    recredentialed: boolean = false;
    notes: string = '';

    constructor(jsonData = {}) {
        super();
        Object.assign(this, this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/profile-status/model/profile-status.model.ts